import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddnewComponent } from './addnew/addnew.component';
import { AssociationsComponent } from './associations.component';

const routes: Routes = [
  {
    path:'associations',
    component:AssociationsComponent
  },
  {
    path:'addnew',
    component:AddnewComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssociationsRoutingModule { }
